import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { nextPage, resetPage } from '../../actions/data';
import NameListFormContainer from './NameListFormContainer';

export class NewListContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    nextPageAction: PropTypes.func.isRequired,
    resetPageAction: PropTypes.func.isRequired,
    datasetForSkuIsPreSelected: PropTypes.bool.isRequired,
  };

  // Fetch fields for logged in user's account
  componentWillMount = () => {
    const { nextPageAction, datasetForSkuIsPreSelected } = this.props;
    if (!datasetForSkuIsPreSelected) {
      nextPageAction(0);
    }
  };

  render() {
    const { accountId, resetPageAction } = this.props;
    return <NameListFormContainer accountId={accountId} resetPageFunction={resetPageAction} />;
  }
}

// Get field list for an account an user state from redux and map it to presentation layer
const mapStateToProps = (state, ownProps) => {
  const { params } = ownProps;
  const accountId = parseInt(params.accountId, 10);
  return {
    accountId,
  };
};

export default connect(mapStateToProps, {
  nextPageAction: nextPage,
  resetPageAction: resetPage,
})(NewListContainer);
